import { render, staticRenderFns } from "./IndividualTagComponent.vue?vue&type=template&id=b63d1d94"
import script from "./IndividualTagComponent.vue?vue&type=script&lang=js"
export * from "./IndividualTagComponent.vue?vue&type=script&lang=js"
import style0 from "./IndividualTagComponent.vue?vue&type=style&index=0&id=b63d1d94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports